import types from "./ActionTypes";
import httpService from "services/httpService";
// Utils
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import getCookie from "Utils/GetCookie";
// import coursesListToMap from "Utils/CoursesListToMap";
import instituteListToMap from "Utils/InstituteListToMap";
import departmentListToMap from "Utils/DepartmentListToMap";
import showProgress from "Components/Common/CustomToast/CustomToast";
import log from "loglevel";
import { uploadCourseImportInChunks, abortCourseImport, isUploadAbortedError, getFileIdentity, PENDING_IMPORT_KEY, CHUNK_SIZE } from "Utils/chunkedCourseImport";


// TODO: Move this to Utils, better create a fetch wrapper in Utils which uses this
// function handleErrorsAndExtractJson(response) {
//   if (!response.ok) {
//     throw Error(response.statusText);
//   }
//   return response.json();
// }

export function loadCoursesListRequest() {
  log.log(httpService.defaults);
  return async (dispatch) => {
    try {
      const response = await httpService.get("/courseware/api/instructor_courses/");
      if (response.status === 200) {
        let courses = response.data["courses"];
        dispatch(loadCoursesListSuccess(courses));
      }
    } catch (err) {
      log.log(err);
      throw err;
    }
  };
}

export function loadArchiveStatus(courseid) {
  return async (dispatch) => {
    let url =
      "/courseware/api/course/" + courseid + "/archive_status/?format=json";
    try {
      const response = await httpService.get(url);
      if (response.status === 200) {
        dispatch(loadArchiveStatusSuccess(courseid, response.data));
      }
    } catch (error) {
      displayGlobalMessage("Request failed...", "error");
      throw error;
    }
  };
}

export function loadImportCoursesListRequest() {
  return async (dispatch) => {
    let get_all_courses_url = "/courseware/api/get_all_courses/?format=json";
    try {
      const response = await fetch(get_all_courses_url);
      const data = await response.json();
      dispatch(loadImportCoursesListSuccess(data));
    } catch (error) {
      displayGlobalMessage("Import Course Failed", "error");
      throw error;
    }
  };
}

export function publishCourse(courseId) {
  return async (dispatch) => {
    try {
      const response = await httpService.post(
        `/courseware/api/course/${courseId}/publish/?format=json`
      );
      if (response.status === 200) {
        displayGlobalMessage(response.data.msg, "success");
        dispatch(publishCourseSuccess(courseId));
      }
    } catch (err) {
      log.log(err);
      throw err;
    }
  };
}

export function downloadCourse(courseId, chaps, assigns) {
  return async (dispatch) => {
    let url = `/courseware/api/course/${courseId}/submit_archive/?format=json`;
    let fd = new FormData();
    fd.append("chapters", chaps);
    fd.append("p_assigns", assigns);
    try {
      const response = await httpService.post(url, fd);
      if (response.status === 200) {
        if (response.data.alert_msg) {
          alert(response.data.alert_msg);
        }
        dispatch(downloadCourseSuccess(courseId));
      }
    } catch (error) {
      displayGlobalMessage("Request failed...", "error");
      throw error;
    }
    // fetch(
    //     url, {
    //     method: 'POST',
    //     headers: { 'X-CSRFToken': getCookie('csrftoken') },
    //     body: fd
    // })
    //     .then(response => response.json())
    //     .then(response => {
    //         if (response.alert_msg) {
    //             alert(response.alert_msg);
    //         }
    //         // displayGlobalMessage(response.msg, 'success');
    //         dispatch(downloadCourseSuccess(courseId));
    //     })
    //     .catch(error => {
    //         displayGlobalMessage('Request failed...', 'error');
    //         throw (error);
    //     });
  };
}

export function deleteArchive(courseId) {
  return async (dispatch) => {
    if (
      confirm("Are you sure you want to delete the archive of this course?")
    ) {
      let url = `/courseware/delete_archive/${courseId}/?format=json`;
      try {
        const response = await httpService.post(url);
        if (response.status === 200) {
          if (response.data.success) {
            displayGlobalMessage(response.data.msg, "success");
            dispatch(deleteArchiveSuccess(courseId));
          } else {
            displayGlobalMessage(response.data.msg, "error");
          }
        }
      } catch (error) {
        displayGlobalMessage("Request failed", "error");
        throw error;
      }
      // fetch(
      //     url, {
      //     method: 'POST',
      //     headers: { 'X-CSRFToken': getCookie('csrftoken') }
      // })
      //     .then(response => response.json())
      //     .then(response => {
      //         if (response.success) {
      //             displayGlobalMessage(response.msg, 'success');
      //             dispatch(deleteArchiveSuccess(courseId));
      //         } else {
      //             displayGlobalMessage(response.msg, 'error');
      //         }
      //     })
      //     .catch(error => {
      //     });
    }
  };
}

export function toggleArchive(courseId) {
  return async (dispatch) => {
    let url = `/courseware/toggle_archive/${courseId}/?format=json`;
    try {
      const response = await httpService.post(url);
      const data = response.data;
      if (data.success) {
        displayGlobalMessage(data.msg, "success");
        dispatch(toggleArchiveSuccess(courseId));
      } else {
        displayGlobalMessage((data.msg || data.error), "error");
      }
    } catch (error) {
      displayGlobalMessage("Request failed", "error");
      throw error;
    }
  };
}

export function deleteCourse(courseId) {
  return async (dispatch) => {
    let url = `/courseware/api/course/${courseId}/`;
    try {
      const response = await httpService.delete(url);
      log.log(response);
      if (response.status === 204) {
        displayGlobalMessage(
          "The course was successfully deleted",
          "success"
        );
        dispatch(deleteCourseSuccess(courseId));
      }
    } catch (err) {
      log.error(err);
      displayGlobalMessage("Request failed", "error");
      // throw error;
    }

    // fetch(url, {
    //   method: "delete",
    //   headers: { "X-CSRFToken": getCookie("csrftoken") },
    // })
    //   .then(() => {
    //     displayGlobalMessage(
    //       "The course was successfully deleted",
    //       "success"
    //     );
    //     dispatch(deleteCourseSuccess(courseId));
    //   })
    //   .catch(() => {
    //     displayGlobalMessage("The course could not be deleted", "error");
    //   });
  };
}

export function getAllInstitute() {
  // log.log(httpService.defaults);
  return async (dispatch) => {
    try {
      const response = await httpService.get("/courseware/get_allinstitutes/");
      if (response.status === 200) {
        let instituteMap = instituteListToMap(response.data["institutes"]);
        dispatch(loadInstituteListSuccess(instituteMap));
      }
    } catch (err) {
      log.log(err);
      throw err;
    }
  };
}

export function getAllDepartment() {
  // log.log(httpService.defaults);
  return async (dispatch) => {
    try {
      const response = await httpService.get("/courseware/get_alldepartments/");
      log.log(response);
      if (response.status === 200) {
        let departmentsMap = departmentListToMap(response.data["departments"]);
        dispatch(loadDepartmentListSuccess(departmentsMap));
      }
    } catch (err) {
      log.log(err);
      throw err;
    }
  };
}

export function addCourse(data) {
  return async (dispatch) => {
    let url = "/courseware/api/offering/?format=json";
    let fd = new FormData();
    fd.append("category", "1");
    fd.append("title", data.title);
    fd.append("enrollment_type", data.enrollment_type);
    if (data.image) {
      fd.append("image", data.image);
    }
    fd.append("institute", data.institute);
    fd.append("department", data.department);
    // fd.append('anonymity', data.anonymity);
    fd.append("notification_toAll", data.notification_toAll);
    fd.append("anonymity_reveal", data.anonymity_reveal);
    fd.append("courseCode", data.courseCode.toUpperCase());
    fd.append("course_type", data.course_type);
    fd.append("import_url", data.import_url);
    fd.append("import_file", data.import_file);
    log.log(fd);
    if (
      data.course_type === "I" &&
      (data.import_url === null || data.import_url === "") &&
      (data.import_file === null || data.import_file === "")
    ) {
      displayGlobalMessage("Import File or URL Not Provided!!", "error");
      return false;
    }
    try {
      const config = {
        onUploadProgress: function(progressEvent) {
          const progressBar = {value: 0, textContent: 0.0};
          log.log({progressBar, progressEvent});
          if (progressEvent.lengthComputable) {
            const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
            progressBar.value = percentComplete;
            progressBar.textContent = `${percentComplete.toFixed(2)}%`;
            // log.log(progressBar);
            showProgress(progressBar.textContent);
          } else {
            showProgress(`100.00`);
          }
          
        }
      };
      const response = await httpService.post(url, fd, config);
      log.log(response);
      if (response.status === 200) {
        dispatch(addCourseSuccess(response.data));
        //       // window.location.href = `/courseware/course/${response.id}`;
        // window.location.href = `/courseware/courselist`;
        return true;
      } else {
        throw Error(response.data.non_field_errors);
      }
    } catch (err) {
      log.log(err);
      displayGlobalMessage(`Add Course Failed: ${err}`, "error");
      throw err;
    }

    // fetch(url, {
    //   method: "POST",
    //   headers: { "X-CSRFToken": getCookie("csrftoken") },
    //   body: fd,
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       let response2 = response.clone();
    //       response2
    //         .json()
    //         .then((data) => ({
    //           data: data,
    //           status: data.status,
    //         }))
    //         .then((data) => {
    //           throw Error(data.data.non_field_errors);
    //         })
    //         .catch((error) => {
    //           log.log(error);
    //           displayGlobalMessage(`Add Course Failed: ${error}`, "error");
    //         });
    //     } else {
    //       return response.json();
    //     }
    //   })
    //   .then((response) => {
    //     if (response) {
    //       dispatch(addCourseSuccess(response));
    //       // window.location.href = `/courseware/course/${response.id}`;
    //       window.location.href = `frontend/courseware/courselist`;
    //     }
    //   })
    //   .catch((error) => {
    //     log.log(error);
    //     displayGlobalMessage(`Add Course Failed: ${error}`, "error");
    //   });
    return false;
  };
}

export function importCourseRequest(srcCourseId, dstCourseTitle) {
  return async (dispatch) => {
    let import_course_url = "/concept/copy_course/?format=json";
    let data = { src_course: srcCourseId, dst_course_title: dstCourseTitle };
    try {
      const response = await fetch(import_course_url, {
        // TODO: add timeout 150000
        method: "POST",
        headers: {
          "X-CSRFToken": getCookie("csrftoken"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (result["success"]) {
        dispatch(importCourseSuccess(result, dstCourseTitle));
        displayGlobalMessage("Course Imported Successfully", "success");
      }
    } catch (error) {
      displayGlobalMessage(`Import Course Failed: ${error}`, "error");
      throw error;
    }
  };
}

export function importCourseSuccess(response, title) {
  let course = {
    id: response.course_id,
    title: title,
    is_published: false,
  };
  return { type: types.IMPORT_COURSE_SUCCESS, course };
}
export function loadArchiveStatusSuccess(courseid, archive) {
  let resp = {
    arch: archive,
    crseid: courseid,
  };
  return { type: types.LOAD_ARCHIVE_STATUS_SUCCESS, resp };
}

export function publishCourseSuccess(courseId) {
  return { type: types.PUBLISH_COURSE_SUCCESS, courseId };
}

export function downloadCourseSuccess(courseId) {
  return { type: types.DOWNLOAD_COURSE_SUCCESS, courseId };
}

export function deleteArchiveSuccess(courseId) {
  return { type: types.DELETE_ARCHIVE_SUCCESS, courseId };
}

export function toggleArchiveSuccess(courseId) {
  return { type: types.DISABLE_ARCHIVE_SUCCESS, courseId };
}

export function deleteCourseSuccess(courseId) {
  return { type: types.DELETE_COURSE_SUCCESS, courseId };
}

export function loadCoursesListSuccess(instructorCoursesMap) {
  return {
    type: types.LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS,
    instructorCoursesMap,
  };
}

export function loadInstituteListSuccess(instituteList) {
  return { type: types.LOAD_INSTITUTE_LIST_SUCCESS, instituteList };
}
export function loadDepartmentListSuccess(departmentList) {
  return { type: types.LOAD_DEPARTMENT_LIST_SUCCESS, departmentList };
}

export function loadCoursesListFailure() {
  return { type: types.LOAD_INSTRUCTOR_COURSES_LIST_FAILURE };
}

export function addCourseSuccess(course) {
  return { type: types.ADD_COURSE_SUCCESS, course };
}

export function loadImportCoursesListSuccess(data) {
  return { type: types.LOAD_IMPORT_COURSES_LIST_SUCCESS, data };
}

export function importCourseProgress(progress) {
  return { type: types.IMPORT_COURSE_PROGRESS, progress };
}

export function importCourseProgressReset() {
  return { type: types.IMPORT_COURSE_PROGRESS_RESET };
}

const apiErrorMessage = (err) => {
  const data = err?.response?.data;
  if (!data) return err?.message || String(err);
  if (typeof data === "string") return data;
  if (data.message) return data.message;
  if (data.msg) return data.msg;
  if (data.detail?.message) return data.detail.message;
  if (data.detail) return data.detail;
  const firstKey = Object.keys(data)[0];
  const value = firstKey ? data[firstKey] : null;
  return Array.isArray(value) ? value[0] : value || err.message;
};

export function addCourseNew(fd) {
  return async (dispatch) => {
    let url = "/courseware/api/offering/?format=json";
    try {
      const config = {
        onUploadProgress: function(progressEvent) {
          const progressBar = {value: 0, textContent: 0.0};
          // log.log({progressBar, progressEvent});
          if (progressEvent.lengthComputable) {
            const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
            progressBar.value = percentComplete;
            progressBar.textContent = `${percentComplete.toFixed(2)}`;
            dispatch(importCourseProgress(progressBar.textContent));
            if (progressEvent.loaded >= progressEvent.total) {
              dispatch(importCourseProgress(`100.00`));
              setTimeout(()=>dispatch(importCourseProgressReset()), 1000);
            }
          } else {
            dispatch(importCourseProgress(`100.00`));
            setTimeout(()=>dispatch(importCourseProgressReset()), 1000);
            dispatch(loadCoursesListRequest())
          }
        }
      };
      const response = await httpService.post(url, fd, config);
      log.log(response);
      if (response.status === 200) {
        dispatch(addCourseSuccess(response.data));
        return true;
      } else {
        throw Error(response.data.non_field_errors);
      }
    } catch (err) {
      log.error(err);
      displayGlobalMessage(`Add Course Failed: ${apiErrorMessage(err)}`, "error");
      return false;
    }
  };
}

export function addCourseImportFromUrl(values) {
  return async () => {
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key !== "import_file" && key !== "image") formData.append(key, values[key]);
    });
    try {
      const response = await httpService.post("/courseware/api/offering/?format=json", formData);
      return response.data;
    } catch (err) {
      log.error(err);
      displayGlobalMessage(
        `Add Course Failed: ${err?.response?.data?.msg || err}`,
        "error"
      );
      throw err;
    }
  };
}

// Import a course from a .tar.gz file using chunked upload (resume + retry). The archive
// is split into 512KB chunks, sent to the backend, reassembled and hash-verified there,
// then handed off to the existing import task. Progress is reported via the same
// importCourseProgress action the ProgressBar already listens to.
export function addCourseImportChunked(values) {
  return async (dispatch) => {
    const onProgress = (progress) => {
      // Never push '100' through here: that would flip uploadRequestStatus to 'UPLOADED'
      // and prematurely close the modal. The component handles the post-upload transition.
      if (!String(progress).includes("100")) {
        dispatch(importCourseProgress(String(progress)));
      }
    };
    // Record a descriptor of this upload so it can be resumed after a page refresh, which
    // kills the in-tab upload Promise. Only the file identity is needed to resume — the form
    // fields were already sent with chunk 0 (see uploadCourseImportInChunks).
    try {
      const file = values.import_file;
      localStorage.setItem(PENDING_IMPORT_KEY, JSON.stringify({
        hash: getFileIdentity(file),
        fileName: file.name,
        size: file.size,
        totalChunks: Math.ceil(file.size / CHUNK_SIZE),
      }));
    } catch (e) {
      log.error(e);
    }
    try {
      await uploadCourseImportInChunks(values, onProgress);
      // Upload finished (all chunks assembled, import triggered) — no longer resumable.
      localStorage.removeItem(PENDING_IMPORT_KEY);
      return true;
    } catch (err) {
      // User-initiated abort is not a failure — stay quiet (abort thunk does the cleanup).
      if (isUploadAbortedError(err)) {
        return false;
      }
      log.error(err);
      dispatch(importCourseProgressReset());
      displayGlobalMessage(`Add Course Failed: ${err}`, "error");
      throw err;
    }
  };
}

// Fetch the read-only tree of what the uploaded archive would create. The backend scans the
// assembled tar without extracting it and caches the result, so re-opening the modal is cheap.
export function loadCourseImportPreview() {
  return async () => {
    const response = await httpService.get("/courseware/api/offering/import_preview/");
    return response.data;
  };
}

// Confirm the previewed archive and start the real import. The whole archive is imported —
// the preview is read-only, so there is nothing to filter.
export function confirmCourseImport(fileId) {
  return async () => {
    const response = await httpService.post(
      "/courseware/api/offering/import_confirm/",
      fileId ? { file_id: fileId } : {}
    );
    return response.data;
  };
}

// Abort an in-progress chunked course import: stop the upload loop, tell the backend to
// delete the partial CourseFolder + chunks, and clear the progress state.
export function abortCourseImportChunked() {
  return async (dispatch) => {
    abortCourseImport();
    localStorage.removeItem(PENDING_IMPORT_KEY);
    try {
      await httpService.post("/courseware/api/offering/import_chunk_cancel/");
    } catch (err) {
      log.error(err);
    }
    dispatch(importCourseProgressReset());
  };
}